import { render, staticRenderFns } from "./help-page.vue?vue&type=template&id=159cfb97"
import script from "./help-page.vue?vue&type=script&lang=js"
export * from "./help-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports